// extracted by mini-css-extract-plugin
export default {"main":"TitleRow-main_GpNmd","legacyRoot":"TitleRow-legacyRoot_T_rgJ","root":"TitleRow-root_EBlDR","icon":"TitleRow-icon_KhmOL"};